import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';
import { FooterAccordion, HeaderAccordion } from '../../../../../utils/models/common.interface';
import { ButtonInduxtry, TextInput } from '../../../../../utils/models/input.interface';

@Component({
  selector: 'accordion-induxtry',
  templateUrl: './accordion-induxtry.component.html',
  styleUrls: ['./accordion-induxtry.component.scss']
})
export class AccordionInduxtryComponent  implements OnInit, OnChanges {

  @ViewChild('panel') panel: MatExpansionPanel;
  @ViewChild('spantitle', { static: false }) spantitleElement: ElementRef;
  @ViewChild('containerHeader', { static: false }) containerHeaderElement: ElementRef;
  @ViewChild('rightDiv', { static: false }) rightElement: ElementRef;

  @Input() header: HeaderAccordion
  @Input() footer: FooterAccordion
  @Input() setPanelState: boolean
  @Input() highlight: boolean;
  @Input() expanded: boolean = false;
  @Input() notExpandedAccordion = false;
  @Input() limitName = true;
  @Input() maxWidthTexts = '50%';

  @Output() buttonValue: EventEmitter<string> = new EventEmitter<string>();
  @Output() editValueTitle: EventEmitter<HeaderAccordion> = new EventEmitter<HeaderAccordion>();
  @Output() getPanelState: EventEmitter<boolean> = new EventEmitter<boolean>();

  width

  edit = false;

  statusPanel = false

  buttonFooter: ButtonInduxtry[];
  buttonInterfaceIcon: ButtonInduxtry[];

  editTitleButton: ButtonInduxtry;

  textInput : TextInput;

  tooltipContent = ''
  showTooltipTitle = false;

  @HostListener('window:resize', ['$event'])
  onResize(event): void {
    this.width = event.target.innerWidth;
    this.changeValueNameTooltip();
  }

  changeValueNameTooltip() {
    if (this.spantitleElement && this.spantitleElement.nativeElement) {
      let maxWidthTextsEl = this.maxWidthTexts;
      if (
        this.containerHeaderElement && this.containerHeaderElement.nativeElement &&
        this.rightElement && this.rightElement.nativeElement
      ) {
        const containerEl = this.containerHeaderElement.nativeElement, rightEl = this.rightElement.nativeElement
        maxWidthTextsEl = `${containerEl.clientWidth - rightEl.clientWidth}px`
      }
      const el = this.spantitleElement.nativeElement;
      this.showTooltipTitle = (el.clientWidth < el.scrollWidth);
      this.tooltipContent = this.showTooltipTitle ? this.titleTooltip(this.header.title) : '';
      this.maxWidthTexts = maxWidthTextsEl;
    }
  }


    ngOnInit(): void {
      this.width = window.innerWidth;
      this.editTitleButton = {label:'BUTTON', icon:'Edit', showLabel:false, customStyle:'tertiary', key:'editHeader', tooltip:'Example'}
      setTimeout(() => {
        this.changeValueNameTooltip();
      }, 25);
    }

    ngOnChanges(changes: SimpleChanges): void {
      if(this.panel){
        this.panel['expanded'] = this.setPanelState
      }
    }

    editTitle(event){
      event[0].stopPropagation();
      this.edit = !this.edit
      this.editTitleButton.icon = this.edit? 'save-accordion' : 'Edit'
      if(!this.edit){
        this.editValueTitle.emit(this.header)
      }
    }

    genericButton(event) {
      this.buttonValue.emit(event[1])
     }

     onClick(event: Event): void {
      event.stopPropagation();
    }


    statePanel(value){
      if (this.notExpandedAccordion) {
        this.panel.close();
      } else {
        this.getPanelState.emit(value);
        this.statusPanel = value
      }
    }

    titleTooltip(title) {
      return `<div style="max-width: 217px;" >
        ${title}
      </div>`
    }
}
